import React from 'react'
import { useObservable, useObserver } from "mobx-react-lite"
import _ from 'lodash'
import { Pane, TextInput, Button, Select } from 'evergreen-ui'
import { useMutation } from '@apollo/react-hooks'
import gql from 'graphql-tag'
import { Link, Route } from 'react-router-dom'
import Section from './Section'

const UPDATE_DOC = gql`
  mutation UpdateDoc($id: String!, $data: String!) {
    updateDoc(data: $data, id: $id)
  }
`;

export default ({ doc, types }) => {
    const activeDoc = useObservable(JSON.parse(doc.data))
    const [updateDoc] = useMutation(UPDATE_DOC);
    const modifyDoc = field => e => {
        const value = e.target ? e.target.value : e
        _.set(activeDoc, field, value)
    }
    const addSection = () => {
        activeDoc.sections.push({
            name: ''
        })
    }
    return useObserver(() => <Pane>
        <Pane>
            {/* <Link to='/docs'>wróć</Link> */}
            <TextInput
                placeholder="Type name"
                value={activeDoc.name}
                onChange={modifyDoc('name')}
            />
            {activeDoc.sections && activeDoc.sections.map(section => {
                return <Pane key={section._id}>
                    <TextInput
                        placeholder="FIeld name"
                        value={section.name}
                        onChange={e => section.name = e.target.value}
                    />
                    <TextInput
                        placeholder="Section icon"
                        value={section.icon}
                        onChange={e => section.icon = e.target.value}
                    />
                    Settings:
                    <Select value={section.settingsView || ''} onChange={e => section.settingsView = e.target.value}>
                        <option value="">Wszyscy</option>
                        <option value="admin">Admin</option>
                    </Select>
                    VIew:
                    <Select value={section.view || ''} onChange={e => section.view = e.target.value}>
                        <option value="">Wszyscy</option>
                        <option value="admin">Admin</option>
                    </Select>
                    {/* <Link to={'/docs/' + doc._id + '/' + section._id}>Przejdź</Link> */}
                </Pane>
            })}
            <Pane onClick={addSection}>New section</Pane>
            <Button onClick={() => updateDoc({
                variables: { id: doc._id, data: JSON.stringify(activeDoc) },
                refetchQueries: ['Docs']
            })}>Save</Button>
        </Pane>
        {/* <Pane>
            <Route path="/docs/:id/:section" exact render={props => {
                return <Section
                    key={props.match.params.section}
                    {...props}
                    types={types}
                    section={activeDoc.sections.find(el => el._id === props.match.params.section)}
                />
            }} />
        </Pane> */}
    </Pane>)
}

